import { getGlobalStatus } from '@/api/user';
import { useQuery } from 'react-query';
import { useAppDispatch } from './useReduxHooks';
import { updateUserInfo } from '@/store/modules/user';

const getExpiryWarning = (date: string) => {
  const expiryDate = new Date(date);
  const today = new Date();
  const twoMonthAfter = new Date(today.setMonth(today.getMonth() + 2));
  // 만료일 두 달 전부터 경고
  return expiryDate.getTime() < twoMonthAfter.getTime();
};

const getIsExpired = (date: string) => {
  if (!date) return false;

  const expiryDate = new Date(date);
  const today = new Date();

  return expiryDate.getTime() < today.getTime();
};

function useGetGlobalStatus(pathname?: string) {
  const dispatch = useAppDispatch();
  const { data: globalStatus } = useQuery(
    ['getGlobalStatus'],
    getGlobalStatus,
    {
      enabled: !(pathname && pathname === '/kiosk'),
      onSuccess: (res) => {
        localStorage.setItem(
          'isKioskSettingVisible',
          JSON.stringify({
            isKioskSettingVisible: res.isKioskSettingVisible,
          }),
        );
        if (res.isGlobalPaymentUsable) {
          localStorage.setItem(
            'isGlobalPaymentUsable',
            JSON.stringify({
              isGlobalPaymentUsable: res.isGlobalPaymentUsable,
            }),
          );
        } else {
          localStorage.removeItem('isGlobalPaymentUsable');
        }
        dispatch(
          updateUserInfo({
            isKioskStore: res.isKioskRefundableHospital,
          }),
        );
      },
    },
  );
  const isExpiryWarning = getExpiryWarning(
    globalStatus?.promotionExpiryDate || '',
  );
  const isExpired = getIsExpired(globalStatus?.promotionExpiryDate || '');

  return {
    isExpiryWarning,
    globalStatus,
    isExpired,
    isOriginalTabletUser:
      globalStatus?.paymentType === 'ORIGINAL' && globalStatus?.hasTablet,
    isKioskTabletUser:
      globalStatus?.paymentType === 'DIRECT' &&
      globalStatus?.isKioskRefundableHospital &&
      globalStatus?.hasTablet,

    isNonRefundCheckPaymentOnlyUser:
      globalStatus?.paymentType === 'DIRECT' &&
      globalStatus?.isGlobalPaymentUsable &&
      globalStatus?.hasTablet,
  };
}

export default useGetGlobalStatus;
